(() => {
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

  const prefetched = new Set();

  const eligibleUrl = (anchor) => {
    if (!anchor || anchor.target || anchor.hasAttribute('download')) return null;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || url.href === window.location.href) return null;
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    if (/\/(cart|checkout|account)(\/|$)/.test(url.pathname)) return null;
    if (url.searchParams.has('preview_theme_id')) return null;
    url.hash = '';
    return url.href;
  };

  const prefetch = (anchor) => {
    const href = eligibleUrl(anchor);
    if (!href || prefetched.has(href)) return;
    prefetched.add(href);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    link.fetchPriority = 'low';
    document.head.appendChild(link);
  };

  const nearestLink = (event) => event.target instanceof Element ? event.target.closest('a[href]') : null;

  document.addEventListener('pointerover', (event) => prefetch(nearestLink(event)), { passive: true, capture: true });
  document.addEventListener('touchstart', (event) => prefetch(nearestLink(event)), { passive: true, capture: true });
  document.addEventListener('focusin', (event) => prefetch(nearestLink(event)), { passive: true, capture: true });

  const warmPrimaryNavigation = () => {
    [...document.querySelectorAll('header a[href], .header a[href]')]
      .map((anchor) => ({ anchor, href: eligibleUrl(anchor) }))
      .filter(({ href }, index, items) => href && items.findIndex((item) => item.href === href) === index)
      .slice(0, 8)
      .forEach(({ anchor }) => prefetch(anchor));
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmPrimaryNavigation, { timeout: 1800 });
  } else {
    setTimeout(warmPrimaryNavigation, 1200);
  }
})();
